import addToCart from './addToCart';
import viewItem from './viewItem';
var events = {
  'product:addToCart': [addToCart],
  'product:details': [viewItem]
};
export default events;